<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <form role="form" @submit.stop.prevent="onSubmit">
      <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
      <div class="vx-row">
        <div class="vx-col mb-2">
          <span>Ativo</span>
          <vs-switch
            color="success"
            v-model="formCadastro.status"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>

      <div v-if="formCadastro.advanceEnabled != null" class="vx-row">
        <div class="vx-col mb-2">
          <span>Antecipação</span>
          <vs-switch
            color="success"
            v-model="formCadastro.advanceEnabled"
            style="width: 60px"
          >
            <span slot="on">Ativo</span>
            <span slot="off">Inativo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <span>Tipo de Pagamento</span>
          <v-select
            :options="tiposPagamentos"
            name="Tipo de Pagamento"
            id="Tipo de Pagamento"
            v-model="formCadastro.idTipoPagamento"
            v-validate="'required'"
            :state="validateState('Tipo de Pagamento')"
            :class="validateClass('Tipo de Pagamento')"
          ></v-select>
        </div>
      </div>

      <div class="vx-row mb-2">
        <div class="vx-col w-full">
          <span>Quantidade Máxima de Parcelas</span>
          <vs-input
            type="number"
            size="large"
            class="w-full"
            name="Quantidade de Parcelas"
            id="Quantidade de Parcelas"
            v-model="formCadastro.qtdParcelas"
            v-validate="'required|min_value:1'"
            :state="validateState('Quantidade de Parcelas')"
            :danger="validateClass('Quantidade de Parcelas')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>

      <div v-if="formCadastro.qtdParcelas > 1" class="vx-row mb-2">
        <div class="vx-col w-full">
          <span>Percentual de Fracionamento por Parcela:</span>
          <table class="table-auto w-full">
            <thead>
              <tr>
                <th class="px-4 py-2">Nº de Parcelas</th>
                <th class="px-4 py-2">% de adicional de fracionamento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(parcela, index) in parcelas" :key="index">
                <td class="border px-4 py-2">{{ parcela.installment }}</td>
                <td class="border px-4 py-2">
                  <money
                    class="vs-inputx vs-input--input normal"
                    icon-pack="feather"
                    icon="icon-percent"
                    name="Adicional de Fracionamento"
                    id="Adicional de Fracionamento"
                    v-model="parcelas[index].fractionation"
                    v-validate="'required'"
                    v-bind="money"
                    :state="validateState('juros-' + index)"
                    :danger="validateClass('juros-' + index)"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                  ></money>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >
          <BotaoSubmit
            variant="success"
            :edit="this.dados.idTipoPagamentoEmpresa == null ? false : true"
            :aguarde="aguardeCadastro"
          ></BotaoSubmit>
        </div>
      </div>
    </form>

    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import * as lang from 'vuejs-datepicker/src/locale';
import vSelect from 'vue-select';
import service from '../../services';
import BotaoSubmit from '../../components/BotaoSubmit';
import { Money } from 'v-money';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
  },
  watch: {
    dados() {
      this.preencheForm();
    },
    'formCadastro.qtdParcelas'(newVal, oldVal) {
      if (newVal > oldVal) {
        const currentLength = this.parcelas.length;
        if (newVal > currentLength) {
          for (let i = currentLength; i < newVal; i++) {
            this.parcelas.push({
              installment: i + 1,
              fractionation: 0,
            });
          }
        } else if (newVal < currentLength) {
          this.parcelas.splice(newVal);
        }
        this.parcelas.sort((a, b) => a.installment - b.installment);
      }
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: true,
      },
      aguardeCadastro: false,
      idEmpresa: null,
      languages: lang,
      funcoesValicao: null,
      tiposPagamentos: [],
      parcelas: [],
      formCadastro: {
        status: true,
        idTipoPagamentoEmpresa: null,
        idEmpresa: null,
        idTipoPagamento: null,
        qtdParcelas: '',
        fractionationInstallment: null,
        advanceEnabled: false,
      },
    };
  },
  methods: {
    preencheForm() {
      if (this.dados.idTipoPagamentoEmpresa) {
        this.formCadastro.idTipoPagamentoEmpresa =
          this.dados.idTipoPagamentoEmpresa;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.idTipoPagamento = {
          id: this.dados.idTipoPagamento,
          label: this.dados.TipoPagamento,
        };
        this.formCadastro.qtdParcelas = this.dados.qtdParcelas;
        this.formCadastro.advanceEnabled = this.dados.advanceEnabled;
        if (this.dados.installments && this.dados.installments.length > 0) {
          this.parcelas = this.dados.installments.map((installment) => ({
            installment: installment.installment,
            fractionation: installment.fractionation,
          }));
          this.parcelas.sort((a, b) => a.installment - b.installment);
        } else {
          this.parcelas = [];
        }
      } else {
        this.resetForm();
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.formCadastro.fractionationInstallment = this.parcelas.map(
        (parcela, index) => ({
          installment: index + 1,
          fractionation:
            parcela.fractionation !== undefined ? parcela.fractionation : 0,
        }),
      );

      var action = 'Atualizar';
      if (!this.formCadastro.idTipoPagamentoEmpresa) {
        action = 'Adicionar';
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('TipoPagamento', action, this.formCadastro)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },

    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });
      });
    },

    resetForm() {
      this.formCadastro = {
        status: true,
        idTipoPagamentoEmpresa: null,
        idEmpresa: null,
        idTipoPagamento: null,
        qtdParcelas: '',
        parcelaAplicarJuros: null,
        jurosMensal: 0,
        advanceEnabled: false,
      };
    },
    onReset(evt) {
      if (this.sideBar == true) {
        this.$emit('cancel');
      } else {
        evt.preventDefault();
        this.resetForm();
        this.$nextTick(() => {
          this.show = true;
        });
      }
    },
  },
  mounted() {
    this.buscaDadosSelects(
      'domTipoPagamento',
      'tiposPagamentos',
      'nomePagamento',
      'idTipoPagamento',
    );
    this.$validator.localize('ptBr', locale);
  },
  components: {
    BotaoSubmit,
    'v-select': vSelect,
    Money,
  },
};
</script>
<!------------ END SCRIPT ------------>
